<template>
  <div class="main-page">
    <section class="page-section mb-3">
      <div class="container-fluid">
        <div class="grid card pt-2 pb-3 justify-content-between">
          <div class="col">
            <div class="">
              <div class="text-3xl font-bold mt-2" style="width: 90vw">
                E-Billing - Statement Reports
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col-12 md:col-3">
            <div class="sticky-item">
              <div class="mb-4">
                <div class="surface-100 p-3 font-bold text-md">
                  Query Section
                </div>
                <form
                  ref="observer"
                  tag="form"
                  @submit.prevent="submitForm()"
                  class="mt-2 card"
                >
                  <div class="">
                    <div class="">
                      <div class="mb-2 font-bold text-sm">Account Number *</div>
                      <div id="ctrl-account_number">
                        <InputText
                          ref="ctrldigital_address"
                          v-model.trim="formData.account_number"
                          label="Account Number"
                          type="text"
                          pattern="^[A-Za-z0-9-]+$"
                          maxlength="12"
                          minlength="12"
                          :disabled="formData.inputFieldDisabled"
                          placeholder="Account Number"
                          class="w-full"
                          :class="getErrorClass('account_number')"
                        >
                        </InputText>
                        <small
                          v-if="isFieldValid('account_number')"
                          class="p-error"
                          >{{ getFieldError("account_number") }}</small
                        >
                      </div>
                    </div>
                    <div class="mt-3">
                      <div class="mb-2 font-bold text-sm">Report Type *</div>
                      <div id="ctrl-statement_type">
                        <Dropdown
                          class="w-full"
                          optionLabel="label"
                          optionValue="value"
                          ref="ctrlstatus"
                          v-model="formData.statement_type"
                          :options="app.menus.statementReportTypesItems"
                          label="Report Type"
                          placeholder="Select ..."
                          :disabled="formData.inputFieldDisabled"
                          :class="getErrorClass('statement_type')"
                        ></Dropdown>
                        <small
                          v-if="isFieldValid('statement_type')"
                          class="p-error"
                          >{{ getFieldError("statement_type") }}</small
                        >
                      </div>
                    </div>
                    <div
                      v-if="formData.statement_type != 'current_bill'"
                      class="mt-3"
                    >
                      <div class="mb-2 font-bold text-sm">Start Date *</div>
                      <div id="ctrl-statement_type">
                        <Calendar
                          :showButtonBar="true"
                          class="w-full"
                          :class="getErrorClass('start_date')"
                          dateFormat="dd-M-yy"
                          v-model="formData.start_date"
                          :showIcon="false"
                          mask="YYYY-MM-DD"
                          :maxDate="formData.max_date"
                          :manualInput="false"
                          outlined
                          dense
                          :disabled="formData.inputFieldDisabled"
                        />
                        <small
                          v-if="isFieldValid('start_date')"
                          class="p-error"
                          >{{ getFieldError("start_date") }}</small
                        >
                      </div>
                    </div>
                    <div
                      v-if="formData.statement_type != 'current_bill'"
                      class="mt-3"
                    >
                      <div class="mb-2 font-bold text-sm">End Date *</div>
                      <div id="ctrl-end_date">
                        <Calendar
                          :showButtonBar="true"
                          class="w-full"
                          :class="getErrorClass('end_date')"
                          dateFormat="dd-M-yy"
                          v-model="formData.end_date"
                          :showIcon="false"
                          :maxDate="formData.max_date"
                          :manualInput="false"
                          mask="YYYY-MM-DD"
                          outlined
                          dense
                          :disabled="formData.inputFieldDisabled"
                        />
                        <small
                          v-if="isFieldValid('end_date')"
                          class="p-error"
                          >{{ getFieldError("end_date") }}</small
                        >
                      </div>
                    </div>
                  </div>
                  <div class="text-center my-3">
                    <Button
                      class="p-button-primary p-button-rounded"
                      type="submit"
                      label="Submit"
                      icon="pi pi-send"
                      v-if="!formData.pageData"
                      :loading="saving"
                    />
                    <Button
                      icon="pi pi-check"
                      label="Done"
                      class="p-button-rounded p-button-outlined p-button-success mx-1"
                      autofocus
                      v-if="formData.pageData"
                      @click="resetForm()"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-9">
            <div class="card" v-if="formData.pageData">
              <!-- -------------- -->
              <div v-if="formData.pageData?.title">
                <div class="text-xl mb-3">
                  {{ formData.pageData?.title }}
                </div>
                <hr />
              </div>
              <!-- -------------- -->
              <div v-if="formData.pageData?.user" class="mb-4">
                <table class="table table-sm mb-0">
                  <tr>
                    <th align="left" valign="middle">
                      <div class="">
                        <div class="title-corners mb-2 font-bold text-center">
                          <h5 class="mb-0">Customer Particulars</h5>
                        </div>
                        <div class="corners">
                          <div class="mb-3 font-bold">
                            <em class="font-light mr-2">Name:</em>
                            {{ formData.pageData?.user["account_name"] }}
                          </div>
                          <div class="mb-3">
                            <em class="font-light mr-2">Location:</em>
                            {{ formData.pageData?.user["region"] }}
                            ,
                            {{ formData.pageData?.user["district"] }}
                          </div>
                          <div class="mb-3">
                            <em class="font-light mr-2">Toll Free:</em>
                          </div>
                          <div class="">
                            <em class="font-light mr-2">Tel: WhatsApp:</em>
                          </div>
                        </div>
                      </div>
                    </th>
                    <th align="right" valign="middle" width="50%">
                      <div class="">
                        <div class="title-corners mb-2 font-bold text-center">
                          <h5 class="mb-0">Account Info</h5>
                        </div>
                        <div class="corners">
                          <div class="mb-3">
                            <em class="font-light mr-2">Customer Number:</em>
                            {{ formData.pageData?.user["account_number"] }}
                          </div>
                          <div class="mb-3">
                            <em class="font-light mr-2">Service Catergory:</em>
                            {{ formData.pageData?.user["service_category"] }}
                          </div>
                          <div class="mb-3">
                            <em class="font-light mr-2"> Meter Number:</em>
                            {{ formData.pageData?.user["meter_number"] }}
                          </div>
                          <div class="">
                            <em class="font-light mr-2"> Meter Type:</em>
                            {{ formData.pageData?.user["meter_type"] }}
                          </div>
                        </div>
                      </div>
                    </th>
                  </tr>
                </table>
              </div>
              <!-- -------------- -->
              <div
                class="page-records"
                v-if="
                  formData.pageData && formData.statement_type != 'current_bill'
                "
              >
                <div>
                  <!-- -------------- -->
                  <DataTable
                    :lazy="true"
                    v-if="
                      formData.pageData && formData.statement_type == 'billing'
                    "
                    :value="formData.pageData.results"
                    dataKey="id"
                    @sort="onSort($event)"
                    class=""
                    :showGridlines="false"
                    :rowHover="true"
                    responsiveLayout="stack"
                  >
                    <Column field="bill_date" header="Date">
                      <template #body="{ data }">
                        {{ $utils.humanDate(data.bill_date) }}
                      </template>
                    </Column>
                    <Column field="meter_num" header="Meter #">
                      <template #body="{ data }">
                        {{ data.meter_num }}
                      </template>
                    </Column>
                    <Column field="bill_period" header="Period">
                      <template #body="{ data }">
                        {{ data.bill_period }}
                      </template>
                    </Column>
                    <Column field="reading" header="Reading">
                      <template #body="{ data }">
                        {{ data.reading }}
                      </template>
                    </Column>
                    <Column field="read_type" header="Read Type">
                      <template #body="{ data }">
                        {{ data.read_type }}
                      </template>
                    </Column>
                    <Column field="tariff" header="Tariff">
                      <template #body="{ data }">
                        {{ data.tariff }}
                      </template>
                    </Column>
                    <Column field="totamt" header="Amount (GHS)">
                      <template #body="{ data }">
                        {{ data.totamt }}
                      </template>
                    </Column>
                    <Column field="cons_billed" header="Qty.Water">
                      <template #body="{ data }">
                        {{ data.cons_billed }}
                      </template>
                    </Column>
                  </DataTable>
                  <vue-chart
                    v-if="
                      formData.pageData &&
                      formData.statement_type == 'billing'
                    "
                    :chart-data="formData.billingChart"
                    chart-type="line"
                    class="mt-4"
                  ></vue-chart>
                  <!-- -------------- -->
                  <DataTable
                    :lazy="true"
                    v-if="
                      formData.pageData &&
                      formData.statement_type == 'statement'
                    "
                    :value="formData.pageData.results"
                    dataKey="id"
                    @sort="onSort($event)"
                    class=""
                    :showGridlines="false"
                    :rowHover="true"
                    responsiveLayout="stack"
                  >
                    <Column field="trans_date" header="Date">
                      <template #body="{ data }">
                        {{ $utils.humanDate(data.trans_date) }}
                      </template>
                    </Column>
                    <Column field="trans_type" header="Type">
                      <template #body="{ data }">
                        {{ data.trans_type }}
                      </template>
                    </Column>
                    <Column field="trans_ref" header="Ref">
                      <template #body="{ data }">
                        {{ data.trans_ref }}
                      </template>
                    </Column>
                    <Column field="no_series" header="Sequence">
                      <template #body="{ data }">
                        {{ data.no_series }}
                      </template>
                    </Column>
                    <Column
                      field="credit"
                      header="Credit"
                      :footer="
                        'Total: ' +
                        $utils.approximate(
                          formData.pageData.results.sum('credit'),
                          1
                        )
                      "
                    >
                      <template #body="{ data }">
                        {{ data.credit }}
                      </template>
                    </Column>
                    <Column
                      field="debit"
                      header="Debit"
                      :footer="
                        'Total: ' +
                        $utils.approximate(
                          formData.pageData.results.sum('debit'),
                          1
                        )
                      "
                    >
                      <template #body="{ data }">
                        {{ data.debit }}
                      </template>
                    </Column>
                    <Column
                      field="balance"
                      header="Balance"
                      :footer="
                        'Total: ' +
                        $utils.approximate(
                          formData.pageData.results.sum('balance'),
                          1
                        )
                      "
                    >
                      <template #body="{ data }">
                        {{ data.balance }}
                      </template>
                    </Column>
                  </DataTable>
                  <vue-chart
                    v-if="
                      formData.pageData &&
                      formData.statement_type == 'statement'
                    "
                    :chart-data="formData.statementChart"
                    chart-type="line"
                    class="mt-4"
                  ></vue-chart>
                  <!-- -------------- -->
                </div>
              </div>
              <div v-else>
                <table id="receipt">
                  <tr class="text-center">
                    <th colspan="2">READING</th>
                    <th>CONSUMPTION DETAILS</th>
                    <th>AMOUNT</th>
                  </tr>
                  <tr class="text-center">
                    <th>
                      PRESENT <br />
                      (IN 1000)
                    </th>
                    <th>
                      PREVIOUS <br />
                      (IN 1000)
                    </th>
                    <th>(IN 1000's)</th>
                    <th>(GHS)</th>
                  </tr>
                  <tr class="text-center">
                    <td>
                      <div>{{ formData.pageData?.results["curr_read"] }}</div>
                    </td>
                    <td>
                      <div>{{ formData.pageData?.results["prev_read"] }}</div>
                    </td>
                    <td class="row-hr">
                      <div>USED</div>
                      <div>WATER AMOUNT</div>
                      <div>WATER CHARGE</div>
                      <div>1% FIRE FIGHTING</div>
                      <div>2% RURAL WATER</div>
                      <div>SEWAGE</div>
                      <div>SERVICE CHARGE</div>
                      <div>CURRENT CHARGES</div>
                      <div>PREVIOUS BALANCE</div>
                      <div>**TOTAL CHARGES</div>
                      <div style="border-bottom: 0px">TOTAL PAYMENTS</div>
                    </td>
                    <td class="row-hr">
                      <div>
                        {{ formData.pageData?.results["consumption"] }} @
                        {{ formData.pageData?.results["water_rate"] }}
                      </div>
                      <div>
                        {{ formData.pageData?.results["water_amount"] }}
                      </div>
                      <div>{{ formData.pageData?.results["water_rate"] }}</div>
                      <div>
                        {{ formData.pageData?.results["fire_fighting"] }}
                      </div>
                      <div>{{ formData.pageData?.results["rural_water"] }}</div>
                      <div>{{ formData.pageData?.results["sewage"] }}</div>
                      <div>
                        {{ formData.pageData?.results["service_charge"] }}
                      </div>
                      <div>{{ formData.pageData?.results["month_total"] }}</div>
                      <div>{{ formData.pageData?.results["prev_bal"] }}</div>
                      <div>
                        {{
                          formData.pageData?.results["month_total"] +
                          formData.pageData?.results["prev_bal"]
                        }}
                      </div>
                      <div style="border-bottom: 0px">
                        ({{ formData.pageData?.results["payment_amount"] }})
                      </div>
                    </td>
                  </tr>
                  <tr class="text-center">
                    <td style="text-align: justify">
                      <div>Last Activity Date</div>
                      <div>Date of Reading</div>
                      <div>Last Payment Date</div>
                    </td>
                    <td style="text-align: justify">
                      <div>
                        {{
                          $utils.humanDate(
                            formData.pageData?.results["last_activity_date"]
                          )
                        }}
                      </div>
                      <div>
                        {{
                          $utils.humanDate(
                            formData.pageData?.results["last_read_date"]
                          )
                        }}
                      </div>
                      <div>
                        {{
                          $utils.humanDate(
                            formData.pageData?.results["last_paid_date"]
                          )
                        }}
                      </div>
                    </td>
                    <td>
                      <div>TOTAL AMOUNT DUE</div>
                    </td>
                    <td>GHS {{ formData.pageData?.results["bal_due"] }}</td>
                  </tr>
                  <tr>
                    <br />
                  </tr>
                  <tr class="text-center">
                    <td style="border: 0px"></td>
                    <td style="background-color: #fdd2d2">
                      <div>PAY AT ONCE</div>
                    </td>
                    <td style="border: 0px">PAY THIS AMOUNT ---></td>
                    <td colspan="4" style="background-color: #fdd2d2">
                      <div>GHS {{ formData.pageData?.results["bal_due"] }}</div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div
              v-else
              style="width: 100%; height: 70vh; background: rgb(235 235 235)"
            >
              <div class="py-4 m-auto text-center hidden-xs">
                <div v-if="saving">
                  <ProgressSpinner
                    style="width: 70px; height: 70px"
                    strokeWidth="1"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { computed, reactive, toRefs, onMounted } from "vue";
import useVuelidate from "@vuelidate/core";
import { required, numeric } from "@/services/validators";
import { utils } from "@/utils";
import { useApp } from "@/composables/app.js";
import { useEBillingPage } from "@/composables/ebillingpage.js";
import VueChart from "@/components/VueCharts.vue";
//[--PAGE-IMPORT-STATEMENT--]
const props = defineProps({
  pageName: {
    type: String,
    default: "ebillingstatements",
  },
  routeName: {
    type: String,
    default: "ebillingstatements",
  },
  apiPath: {
    type: String,
    default: "ebilling/statements",
  },
  submitButtonLabel: {
    type: String,
    default: "Submit",
  },
  formValidationError: {
    type: String,
    default: "Form is invalid",
  },
  formValidationMsg: {
    type: String,
    default: "Please complete the form",
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});

const app = useApp();
const formDefaultValues = {
  pageData: null,
  inputFieldDisabled: false,
  statementChart: {},
  billingChart: {},
  account_number: "",
  statement_type: "current_bill",
  max_date: new Date(),
  start_date: new Date(),
  end_date: new Date(),
};
const formData = reactive({ ...formDefaultValues });
//form validation rules
const rules = computed(() => {
  return {
    account_number: { required },
    statement_type: { required },
    start_date: { required },
    end_date: { required },
  };
});
const v$ = useVuelidate(rules, formData); // form validation
const page = useEBillingPage({
  props,
  formData,
  v$,
  beforeSubmit,
  afterSubmit,
});
// perform custom validation before submit form
// set custom form fields
// return false if validation fails
function beforeSubmit() {
  Object.assign(formData, { pageData: null, statementChart: {}, billingChart: {} });
  return true;
}
// after form submited to api
// reset form data.
// redirect to another page
function afterSubmit(response) {
  Object.assign(formData, { pageData: response, inputFieldDisabled: true });
  if (response?.results && formData.statement_type == "statement") {
    let statementDataset = {
      labels: response?.results.map((i) => utils.humanDate(i.trans_date)),
      datasets: [
        {
          data: response?.results.map((i) => i.balance),
          label: "",
          fill: false,
          borderColor: "#42A5F5",
          tension: 0.4,
        },
      ],
    };
    Object.assign(formData, { statementChart: statementDataset });
  }

  if (response?.results && formData.statement_type == "billing") {
    let billingDataset = {
      labels: response?.results.map((i) => utils.humanDate(i.bill_date)),
      datasets: [
        {
          data: response?.results.map((i) => i.totamt),
          label: "Amount",
          fill: false,
          borderColor: "#42A5F5",
          tension: 0.4,
        },
      ],
    };
    Object.assign(formData, { billingChart: billingDataset });
  }
}

function resetForm() {
  Object.assign(formData, { pageData: null, inputFieldDisabled: false });
}
//page state
const {
  submitted, // form submitted state - Boolean
  saving, // form api submiting state - Boolean
  pageReady, // if api data loaded successfully
} = toRefs(page.state);
//page methods
const {
  submitForm, //submit form data to api
  getErrorClass, // return error class if field is invalid- args(fieldname)
  getFieldError, //  get validation error message - args(fieldname)
  isFieldValid, // check if field is validated - args(fieldname)
  // map api datasource  to Select options label-value
} = page.methods;

onMounted(() => {
  const pageTitle = "E-Billing - Statement Reports";
  app.setPageTitle(props.routeName, pageTitle);
});
// expose page object for other components access
defineExpose({
  page,
});
</script>
<style scoped>
table,
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #eceeef;
  text-align: left;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #eceeef;
  text-align: left;
}

.table tbody + tbody {
  border-top: 2px solid #eceeef;
}

.table .table {
  background-color: #fff;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #eceeef;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #eceeef;
}

.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.title-corners {
  border: 4px solid #a6cffb;
  padding: 5px;
  background-color: #a6cffb;
  color: #000;
}

.corners {
  border: 2px solid #4a5685;
  padding: 15px;
}

.receipt {
  border-collapse: collapse;
  width: 100%;
}

.receipt td,
th,
td {
  border: 1px solid #a4a4a4;
  padding: 8px;
}

.receipt tr:nth-child(even) {
  background-color: #f2f2f2;
}

.receipt tr:hover {
  background-color: #ddd;
}

.receipt #th-corners {
  border-top: 2px solid #25b2c7;
  border-radius: 6px;
}

.receipt th {
  text-align: left;
  background-color: #a6cffb;
  color: black;
  text-align: center;
}

.receipt td {
  text-align: center;
  background-color: #fbfbfb;
}

.receipt.td-text-left td {
  text-align: left;
  background-color: #fbfbfb;
}
</style>
